export default __webpack_public_path__ + "static/media/whatsapp.6b35e013.svg";